var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"bg-default-card",attrs:{"header":_vm.uLang('app.create'),"header-tag":"h4"}},[_c('form-admin-relation',{attrs:{"organisation-id":_vm.organisationId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }